if (!customElements.get('garden-stake-personalization')) {
  customElements.define('garden-stake-personalization', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.form = this.closest('form');
      this.photoInput = this.querySelector('[data-stake-photo]');
      this.photoPreview = this.querySelector('[data-stake-photo-preview]');
      this.nameInput = this.querySelector('[data-stake-name]');
      this.datesInput = this.querySelector('[data-stake-dates]');
      this.messageInput = this.querySelector('[data-stake-message]');
      this.confirm = this.querySelector('[data-stake-confirm]');
      this.error = this.querySelector('[data-stake-error]');
      this.status = this.querySelector('[data-stake-status]');
      this.dialog = this.querySelector('[data-stake-dialog]');
      this.form.addEventListener('input', event => {
        if (event.target !== this.confirm) this.confirm.checked = false;
        this.validateText();
      }, options);
      this.form.addEventListener('change', event => {
        if (event.target !== this.confirm) this.confirm.checked = false;
        if (event.target === this.photoInput) this.loadPhoto();
        if (event.target.matches('[data-stake-style], [data-stake-color]')) this.updateOptions();
      }, options);
      this.querySelector('[data-stake-remove]').addEventListener('click', () => {
        this.photoInput.value = ''; this.loadPhoto(); this.confirm.checked = false;
      }, options);
      this.querySelector('[data-stake-enlarge]').addEventListener('click', event => {
        this.opener = event.currentTarget; this.dialog.showModal();
        document.documentElement.classList.add('garden-stake-viewer-open');
        this.dialog.querySelector('[data-stake-close]').focus();
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog || event.target.closest('[data-stake-close]')) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('garden-stake-viewer-open');
        this.opener?.focus({preventScroll: true});
      }, options);
      this.form.addEventListener('submit', event => this.add(event), {...options, capture: true});
      this.updateOptions(); this.dataset.ready = 'true';
    }

    updateOptions() {
      const style = this.querySelector('[data-stake-style]:checked');
      const color = this.querySelector('[data-stake-color]:checked');
      this.querySelector('[data-stake-color-name]').textContent = color.value;
      this.querySelector('[data-stake-style-name]').textContent = style.value;
      const noMessage = ['C', 'F'].includes(style.dataset.stakeStyle);
      this.messageInput.disabled = noMessage;
      this.messageInput.required = !noMessage;
      this.querySelector('[data-stake-message-wrap]').hidden = noMessage;
      this.querySelector('[data-stake-no-message]').hidden = !noMessage;
      const image = this.dialog.querySelector('img');
      image.src = style.dataset.image;
      image.alt = style.value;
      this.validateText();
    }

    validateText() {
      [this.nameInput, this.datesInput, this.messageInput].forEach(input => {
        input.setCustomValidity(!input.disabled && !input.value.trim() ? this.dataset.textError : '');
      });
    }

    async loadPhoto() {
      const version = this.photoVersion = (this.photoVersion || 0) + 1;
      if (this.photoUrl) URL.revokeObjectURL(this.photoUrl);
      this.photoUrl = null; this.photoReady = false; this.loadingPhoto = false;
      this.photoInput.setCustomValidity(''); this.error.hidden = true; this.status.textContent = '';
      this.photoPreview.hidden = true; this.photoPreview.removeAttribute('src');
      this.querySelector('[data-stake-photo-review]').hidden = true;
      const file = this.photoInput.files[0];
      this.querySelector('[data-stake-remove]').hidden = !file;
      if (!file) return;
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
        this.photoInput.value = ''; this.photoInput.setCustomValidity(this.dataset.photoError);
        this.showError(this.dataset.photoError); return;
      }
      const url = URL.createObjectURL(file); this.photoUrl = url;
      this.loadingPhoto = true; this.status.textContent = this.dataset.loadingPhoto;
      try {
        const image = new Image(); image.src = url; await image.decode();
        if (version !== this.photoVersion || !this.isConnected) return;
        if (!image.naturalWidth || image.naturalWidth * image.naturalHeight > 80000000) throw new Error('Invalid photo');
        this.photoReady = true; this.photoPreview.src = url; this.photoPreview.hidden = false;
        this.querySelector('[data-stake-photo-review]').hidden = false;
        this.status.textContent = file.name;
      } catch {
        if (version !== this.photoVersion || !this.isConnected) return;
        URL.revokeObjectURL(url); this.photoUrl = null; this.photoInput.value = '';
        this.photoInput.setCustomValidity(this.dataset.photoError);
        this.showError(this.dataset.photoError); this.status.textContent = '';
      } finally {
        if (version === this.photoVersion) this.loadingPhoto = false;
      }
    }

    showError(message) { this.error.textContent = message; this.error.hidden = false; }

    async add(event) {
      event.preventDefault(); event.stopImmediatePropagation();
      const submit = this.form.querySelector('[data-product-submit]');
      if (this.busy || submit.disabled) return;
      this.validateText();
      if (!this.form.reportValidity()) return;
      if (this.loadingPhoto || !this.photoReady) { this.showError(this.dataset.photoError); return; }
      const data = new FormData(this.form);
      [this.nameInput, this.datesInput, this.messageInput].filter(input => !input.disabled).forEach(input => data.set(input.name, input.value.trim()));
      this.busy = true; this.error.hidden = true; submit.disabled = true;
      const label = submit.querySelector('[data-submit-label]'), previous = label.textContent;
      label.textContent = submit.dataset.addingLabel;
      try {
        const action = new URL(this.form.action, location.origin);
        const response = await fetch(action.pathname.replace(/\/$/, '') + '.js', {method: 'POST', headers: {Accept: 'application/json'}, body: data});
        if (!response.ok) throw new Error('Add failed');
        await response.json();
        document.dispatchEvent(new CustomEvent('echoes:cart-refresh', {detail: {open: true}}));
      } catch {
        this.showError(this.dataset.addError);
      } finally {
        this.busy = false; submit.disabled = false; label.textContent = previous;
      }
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('garden-stake-viewer-open');
      this.controller?.abort(); this.controller = null;
      this.photoVersion = (this.photoVersion || 0) + 1;
      if (this.photoUrl) URL.revokeObjectURL(this.photoUrl);
    }
  });
}
